export default {fields:{},spreads:{BaseStorableSchema:{}}}